import { render, staticRenderFns } from "./questionType12.vue?vue&type=template&id=9e3d77c6"
import script from "./questionType12.vue?vue&type=script&lang=js"
export * from "./questionType12.vue?vue&type=script&lang=js"
import style0 from "./questionType12.vue?vue&type=style&index=0&id=9e3d77c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports